import { Card, TextField, Grid, InputLabel, MenuItem, Select, Typography, Stack, Button, Autocomplete, Box, FormControlLabel, Checkbox } from '@mui/material'
import { Container } from '@mui/system'
import { useEffect, useState } from 'react';
import { UrlApi } from '../../services/apirest';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment'


export default function Viajes(props) {

  const usuario = props.deresumen ? props.datos.chofer : localStorage.getItem("user")
  const dominio = props.editar ? props.datos.dominio : localStorage.getItem("patente")
  const [sucursal, setSucursal] = useState("");
  const [periodo, setPeriodo] = useState([])
  const [kmstotal, setKmsTotal] = useState()

  const [destino, setDestino] = useState(props.editar ? props.datos.destino : "");
  const [boca, setBoca] = useState(props.editar ? props.datos.boca : "")
  const [origen, setOrigen] = useState(props.editar ? props.datos.origen : "");
  const [fecha, setFecha] = useState(moment(props.editar ? props.datos.fechaviaje : new Date()).format("YYYY-MM-DD"))
  const [fechafinal, setFechaFinal] = useState(moment(props.editar ? props.datos.fechafinal : new Date()).format("YYYY-MM-DD"))
  const [kmsInicio, setKmsInicio] = useState(props.editar ? props.datos.kmsinicio : 0)
  const [kmsFinal, setKmsFinal] = useState(props.editar ? props.datos.kmsfinal : 0)
  const [remito, setRemito] = useState(props.editar ? props.datos.remito : 0)
  const [feriado, setFeriado] = useState(props.editar ? (props.datos.feriado === 'Si' ? true : false) : false)
  const [vacio, setVacio] = useState(props.editar ? (props.datos.vacio === 'Si' ? true : false) : false)



  useEffect(() => {
    obtenerSucursales();
    obtenerfechasperiodo();
    !props.editar && obtenerkmsfinales()
  }, [])

  useEffect(() => {
    setKmsTotal(kmsFinal - kmsInicio);
  }, [kmsFinal, kmsInicio])

  const cerraresto = () => {
    props.setOpenViajes(false)
    props.setOpenViajesMostrar(true)
    props.setRefrescar(!props.setRefrescar)
  }

  const handleChange = (newValue) => {
    setFecha(moment(newValue).format("YYYY-MM-DD"));
  };

  ///Traer sucursales para los selects
  const obtenerSucursales = async () => {
    const data = await fetch(UrlApi + "/viajest1/origendestino")
    const sucursalesData = await data.json()
    await setSucursal(sucursalesData)
  }

  const obtenerfechasperiodo = async () => {
    const datap = await fetch(UrlApi + "/viajest1/periodo/actual")
    const dataperiodos = await datap.json()
    setPeriodo(dataperiodos)
  }

  const obtenerkmsfinales = async () => {
    const datak = await fetch(UrlApi + "/viajest1/kmsfinales/" + dominio)
    const datakmsfinal = await datak.json()
    setKmsInicio(datakmsfinal[0].kmsfinal)
  }

  const grabarViajes = async (e) => {
    e.preventDefault()
    kmstotal > 0 ?
      await fetch(UrlApi + '/viajest1', {
        method: "POST", headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fechaviaje: fecha,
          fechafinal: fechafinal,
          chofer: usuario,
          dominio: dominio,
          kmsinicio: kmsInicio,
          kmsfinal: kmsFinal,
          origen: origen,
          boca: boca,
          destino: destino,
          usuario: usuario,
          remito: remito,
          feriado: feriado ? 'Si' : 'No',
          Vacio: vacio ? 'Si' : 'No'
        })
      }).then((res) => {
        if (res.ok) {
          cerraresto()
        } else {
          alert("Todo mal")
        }
      })
        .catch((err) => {
          console.log(err.message);
        }) : alert("kms finales menor a kms iniciales")
  }

  const updateviajes = async (e) => {
    e.preventDefault()
    kmstotal > 0 ?
      await fetch(UrlApi + '/viajest1/' + props.datos.idviajes_t1, {
        method: "PUT", headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fechaviaje: fecha,
          fechafinal: fechafinal,
          chofer: usuario,
          dominio: dominio,
          kmsinicio: kmsInicio,
          kmsfinal: kmsFinal,
          origen: origen,
          boca: boca,
          destino: destino,
          usuario: usuario,
          remito: remito,
          feriado: feriado ? 'Si' : 'No',
          Vacio: vacio ? 'Si' : 'No'
        })
      }).then((res) => {
        if (res.ok) {
          cerraresto()
        } else {
          alert("Todo mal")
        }
      })
        .catch((err) => {
          console.log(err.message);
        }) : alert("kms finales menor a kms iniciales")
  }

  return (
    <div>
      <Container sx={{ marginTop: '50px', marginLeft: '2px' }}>
        {console.log("sucursales", sucursal)}
        {periodo.length > 0 ?
          <form onSubmit={props.editar ? updateviajes : grabarViajes}>
            <Grid container style={{ width: '300px' }} >
              <Stack spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Typography variant='h5'>
                    {props.editar ? "Editando Viaje - " : "Nuevo Viaje - "} {dominio}
                  </Typography>
                </Grid>
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <TextField
                      name="fecha"
                      required
                      label="Inicio"
                      value={fecha}
                      onChange={(e) =>
                        setFecha(moment(e.target.value).format("YYYY-MM-DD"))
                      }
                      type="date"
                      size="small"
                      fullWidth
                      inputProps={{
                        min: moment(periodo[0].desde).format("YYYY-MM-DD"),
                        max: moment(periodo[0].hasta).format("YYYY-MM-DD")
                      }}
                    />
                  </Grid>
                  {console.log(moment(periodo[0].desde).format("YYYY-MM-DD"))}
                  <Grid item xs={6}>
                    <TextField
                      name="hasta"
                      required
                      label="Final"
                      value={fechafinal}
                      onChange={(e) =>
                        setFechaFinal(moment(e.target.value).format("YYYY-MM-DD"))
                      }
                      type="date"
                      size="small"
                      fullWidth
                      inputProps={{
                        min: fecha,
                        max: moment(periodo[0].hasta).format("YYYY-MM-DD")
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container >
                  <Grid item xs={3} sm={3}>
                    <FormControlLabel
                      control={<Checkbox checked={feriado} onChange={(e) => setFeriado(e.target.checked)} />}
                      label="Fdos"
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <FormControlLabel
                      control={<Checkbox checked={vacio} onChange={(e) => setVacio(e.target.checked)} />}
                      label="Vacio"
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      required={!vacio}
                      label="Numero de Remito"
                      value={remito}
                      type="number"
                      size="small"
                      onChange={(e) => setRemito(e.target.value)} />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>

                  <Card>
                    <Card item>
                      <InputLabel>Origen</InputLabel>
                      <Select
                        required
                        size="small"
                        fullWidth={true}
                        margin="dense"
                        labelId="sucursal"
                        id="sucursal"
                        value={origen}
                        onChange={(e) => { setOrigen(e.target.value); }}
                        inputProps={{ style: { background: "LightYellow" } }}
                      >
                        {sucursal ? sucursal.filter(suc => suc.tipo === 'planta').map(elemento => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.nombre}
                          </MenuItem>
                        )) : null}
                      </Select>
                    </Card>
                    <Card>
                      <Card item>
                        <InputLabel>Boca carga</InputLabel>
                        <Select
                          //required
                          size="small"
                          fullWidth={true}
                          margin="dense"
                          labelId="boca"
                          id="sucursal"
                          value={boca}
                          onChange={(e) => { setBoca(e.target.value); }}
                          inputProps={{ style: { background: "LightYellow" } }}
                        >
                          {sucursal ? sucursal.filter(suc => suc.tipo === 'boca').map(elemento => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.nombre}
                            </MenuItem>
                          )) : null}
                        </Select>
                      </Card>
                      <Card item>
                        <InputLabel>Destino</InputLabel>
                        <Select
                          required
                          size="small"
                          fullWidth={true}
                          margin="dense"
                          labelId="sucursal"
                          id="sucursal"
                          value={destino}
                          onChange={(e) => { setDestino(e.target.value); }}
                          inputProps={{ style: { background: "LightYellow" } }}
                        >
                          {sucursal ? sucursal.filter(suc => suc.tipo === 'planta').map(elemento => (
                            <MenuItem key={elemento.id} value={elemento.id}>
                              {elemento.nombre}
                            </MenuItem>
                          )) : null}
                        </Select>

                        <Card item>
                          <br></br>
                          <Grid container direction="row">
                            <Grid item xs={6}>
                              <TextField
                                label="Kms Inicio"
                                value={kmsInicio}
                                type="number"
                                size="small"
                                onChange={(e) => setKmsInicio(e.target.value)}
                                InputProps={{
                                  readOnly: kmsInicio > 0 ? true : false,
                                }}
                              />

                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                required
                                label="Kms Final"
                                value={kmsFinal}
                                type="number"
                                size="small"
                                onChange={(e) => setKmsFinal(e.target.value)} />

                            </Grid>
                            <Grid item xs={12} style={{ height: '30px' }}>
                              <Typography variant="h6" style={{ color: kmstotal * 1 < 0 ? "red" : "green" }}>Total   {isNaN(kmstotal) ? 0 : kmstotal} Kms</Typography>
                            </Grid>

                          </Grid>
                          <Grid container style={{ textAlign: "center" }}>
                            <Grid item xs={6}>
                              <Button variant="contained" color="error" style={{ height: '30px' }} onClick={cerraresto} >Cancelar
                              </Button>
                            </Grid>
                            <Grid item xs={6}>
                              <Button variant="contained" type="submit" color="success" style={{ height: '30px' }}>Registrar
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>

                      </Card>
                    </Card>
                  </Card>
                </Grid>
              </Stack>
            </Grid>
            <br></br><br></br><br></br><br></br>
          </form>

          : <Typography variant='h6'>No hay periodo abierto para la fecha actual</Typography>}
      </Container>
    </div>
  )
}
